import React from 'react'
import './AthleteImage.css'
import '../layout/Spinner.css'
import Slider from "react-slick"

var athleteImageOne = 'None'
var athleteImageTwo = 'None'
var athleteImageThree = 'None'
var athleteImageFour = 'None'
var athleteImageFive = 'None'

var athleteimageHighSchoolOne = 'None'
var athleteimageHighSchoolTwo = 'None'
var athleteimageHighSchoolThree = 'None'
var athleteimageHighSchoolFour = 'None'
var athleteimageHighSchoolFive = 'None'

var imageCount = 0
var schoolimageCount = 0

const AthleteImage = (props) => {



        const athleteImage = props.athleteImage

        var finalImageSlider = null
        var displayImage = null
        var schooldisplayImage = null

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: 2000,
            cssEase: "linear"
          }

          if (athleteImage) {

            if (athleteImage.imageOne && athleteImage.imageOne !== 'None') {
                athleteImageOne = athleteImage.imageOne
                imageCount = imageCount + 1
            }
            if (athleteImage.imageTwo && athleteImage.imageTwo !== 'None') {
                athleteImageTwo = athleteImage.imageTwo
                imageCount = imageCount + 1
            }
            if (athleteImage.imageThree && athleteImage.imageThree !== 'None') {
                athleteImageThree = athleteImage.imageThree
                imageCount = imageCount + 1
            }
            if (athleteImage.imageFour && athleteImage.imageFour !== 'None') {
                athleteImageFour = athleteImage.imageFour
                imageCount = imageCount + 1
            }
            if (athleteImage.imageFive && athleteImage.imageFive !== 'None') {
                athleteImageFive = athleteImage.imageFive
                imageCount = imageCount + 1
            }

            switch(imageCount) {
                case 1:
                    displayImage = (
                        <div className="AthleteImagesGroupContainer" style={{padding:"0px 75px 26px 75px"}}>
                            <Slider {...settings}>
                                <div>
                                <img src={athleteImageOne} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                imageCount = 0
                break
                case 2:
                    displayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settings}>
                                <div>
                                <img src={athleteImageOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageTwo} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                imageCount = 0
                break
                case 3:
                    displayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settings}>
                                <div>
                                <img src={athleteImageOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageTwo} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageThree} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                imageCount = 0
                break
                case 4:
                    displayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settings}>
                                <div>
                                <img src={athleteImageOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageTwo} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageThree} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageFour} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                imageCount = 0
                break
                case 5:
                    displayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settings}>
                                <div>
                                <img src={athleteImageOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageTwo} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageThree} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageFour} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteImageFive} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                imageCount = 0
                break
                default:
                // no images

                displayImage = null
                imageCount = 0
            }
          }

        //   School Image Box 

        const settingsSchool = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: 1800,
            cssEase: "linear"
          }

          if (athleteImage) {

            if (athleteImage.imageHighSchoolOne && athleteImage.imageHighSchoolOne !== 'None') {
                athleteimageHighSchoolOne = athleteImage.imageHighSchoolOne
                schoolimageCount = schoolimageCount + 1
            }
            if (athleteImage.imageHighSchoolTwo && athleteImage.imageHighSchoolTwo !== 'None') {
                athleteimageHighSchoolTwo = athleteImage.imageHighSchoolTwo
                schoolimageCount = schoolimageCount + 1
            }
            if (athleteImage.imageHighSchoolThree && athleteImage.imageHighSchoolThree !== 'None') {
                athleteimageHighSchoolThree = athleteImage.imageHighSchoolThree
                schoolimageCount = schoolimageCount + 1
            }
            if (athleteImage.imageHighSchoolFour && athleteImage.imageHighSchoolFour !== 'None') {
                athleteimageHighSchoolFour = athleteImage.imageHighSchoolFour
                schoolimageCount = schoolimageCount + 1
            }
            if (athleteImage.imageHighSchoolFive && athleteImage.imageHighSchoolFive !== 'None') {
                athleteimageHighSchoolFive = athleteImage.imageHighSchoolFive
                schoolimageCount = schoolimageCount + 1
            }

            switch(schoolimageCount) {
                case 1:
                    schooldisplayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settingsSchool}>
                                <div>
                                <img src={athleteimageHighSchoolOne} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                schoolimageCount = 0
                break
                case 2:
                    schooldisplayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settingsSchool}>
                                <div>
                                <img src={athleteimageHighSchoolOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolTwo} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                schoolimageCount = 0
                break
                case 3:
                    schooldisplayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settingsSchool}>
                                <div>
                                <img src={athleteimageHighSchoolOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolTwo} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolThree} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                schoolimageCount = 0
                break
                case 4:
                    schooldisplayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settingsSchool}>
                                <div>
                                <img src={athleteimageHighSchoolOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolTwo} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolThree} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolFour} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                schoolimageCount = 0
                break
                case 5:
                    schooldisplayImage = (
                        <div className="AthleteImagesGroupContainer">
                            <Slider {...settingsSchool}>
                                <div>
                                <img src={athleteimageHighSchoolOne} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolTwo} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolThree} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolFour} alt="Athlete Thumbnail"/>
                                </div>
                                <div>
                                <img src={athleteimageHighSchoolFive} alt="Athlete Thumbnail"/>
                                </div>
                            </Slider>
                    </div>
                )
                schoolimageCount = 0
                break
                default:
                // no images

                schooldisplayImage = null
                schoolimageCount = 0
            }
          }

          finalImageSlider = (
              <React.Fragment>
                    <div className="athleteImage">{displayImage}</div>
                    <div className="athleteSchoolImage">
                        {schooldisplayImage != null && (<h3 style={{fontSize:"25px",margin:"0px 0px 25px 60px",justifyItems:"left",display:"grid"}}>School Schedule</h3>)}
                        {schooldisplayImage}</div>
              </React.Fragment>
          )

            return finalImageSlider
}

export default AthleteImage